import { SALE_TYPE } from "../constants";
import { getContractABI, getContractAddress } from "../utils/abiHelper";
import { ether, getWeb3IfAvailable, parseError, toNumber, toRealNumber } from "../web3Utils";
import { ContractService } from "./ContractService";


export class SaleModuleService extends ContractService{

    constructor(args = {}) {
        super();
        this.contractType = 'SaleModule'
        this.abi = getContractABI(this.contractType);
        this.addHooks();
    }

    async preHook() {
        this.web3 = await getWeb3IfAvailable()
        this.accounts = await this.web3.eth.getAccounts();
        this.contractAddress = await getContractAddress(this.contractType);
        this.nftAddress = await getContractAddress('MonstersClanNft');
        this.contractInstance = new this.web3.eth.Contract(
            this.abi,
            this.contractAddress
        );
    }
    
    async getMarketItem(
        tokenId
    ) {
        try{
            console.log('tokenId', tokenId)
            const marketItem = await this.contractInstance
                .methods
                .getMarketItem(
                    this.nftAddress,
                    tokenId
                ).call();
         
            return {
                ...marketItem,
                saleType: SALE_TYPE['NORMAL'],
                price: toNumber(marketItem.price),
                startTime: toRealNumber(marketItem.startTime),
                endTime: toRealNumber(marketItem.endTime),
            }
        } catch(err) {
            throw parseError(err);
        }
    }

    async purchase({
        tokenId,
        value
    }) {
        console.log('tokenId', tokenId, this.nftAddress)
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let args = [
                this.nftAddress,
                tokenId,
                ether(value),
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .purchase( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .purchase( ...args )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'NFT purchased successfully!';
    }

    async listItem({
        tokenId,
        price,
        startTime,
        endTime,
    }) {
        try {

            const gasPrice = await this.web3.eth.getGasPrice();

            let args = [
                this.nftAddress,
                tokenId,
                ether(price),
                Number(startTime),
                Number(endTime),
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .listItem( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .listItem( ...args )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'Item listed for normal sale successfully!';
    }

    async unlistItem({
        tokenId,
    }) {
        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let args = [
                this.nftAddress,
                tokenId,
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance
                .methods
                .unListItem( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .unListItem( ...args )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }
        return 'Item unlisted successfully!';
    }

}